(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holiday-sale-banner"]) return;
  try {
    
(() => {
  function mount(root = document) {
    root.querySelectorAll('[data-grinch-sale]').forEach(banner => {
      if (banner.dataset.mounted) return;
      banner.dataset.mounted = 'true';
      const end = Date.parse(banner.dataset.saleDeadline || '');
      if (!Number.isFinite(end)) return;
      let timer;
      const tick = () => {
        if (!banner.isConnected) { clearInterval(timer); return; }
        const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        banner.hidden = remaining === 0;
        if (!remaining) { clearInterval(timer); return; }
        const values = {hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60};
        banner.querySelectorAll('[data-grinch-time]').forEach(node => { node.textContent = String(values[node.dataset.grinchTime]).padStart(2, '0'); });
      };
      tick();
      if (!banner.hidden) timer = setInterval(tick, 1000);
      banner.querySelector('[data-grinch-sale-close]').addEventListener('click', () => { clearInterval(timer); banner.hidden = true; document.querySelector('.brand')?.focus(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
